import { Routes } from "@angular/router";

const loadHomeComponent = () => import('./home/home.component').then(m => m.HomeComponent);

export const routes: Routes = [
    { path: ':unit/:carrier/:type', loadComponent: loadHomeComponent },
    { path: 'setup', loadComponent: () => import('./shipment-setup/shipment-setup.component').then(m => m.ShipmentSetupComponent) },
    { path: 'links', loadComponent: () => import('./links/links.component').then(m => m.LinksComponent) },
    { path: '**', loadComponent: loadHomeComponent }
];